import { Flex } from 'foundations-components/components/Flex';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPortalBasename } from '../utils/metadata';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PageNotFound({
  homePath
}) {
  var _ref;
  const resolvedHomePath = (_ref = homePath !== null && homePath !== void 0 ? homePath : getPortalBasename()) !== null && _ref !== void 0 ? _ref : '/';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minBlockSize: "100%",
    padding: "800",
    gap: "400",
    children: [/*#__PURE__*/_jsx(H2, {
      color: "text-core-default",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.notFound.heading"
      })
    }), /*#__PURE__*/_jsx(Paragraph, {
      color: "text-core-subtle",
      textAlign: "center",
      marginBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.notFound.body"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "primary",
      href: resolvedHomePath,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.notFound.goHome"
      })
    })]
  });
}